<template>
  <article
    class="grid relative grid-rows-1 gap-y-1 lg:gap-x-17"
  >
    <MajorityUiMajorityLink
      class="absolute w-full h-full z-10"
      tracking-name="communityArticleBlock"
      tracking-type="community content"
      :to="to"
    />
    <figure
      class="select-none flex relative justify-center items-center col-start-1 lg:col-start-2 mb-3 lg:mb-0 bg-middle-light ar-4by3"
    >
      <div
        v-if="hasTag"
        class="tag uppercase absolute font-medium tracking-01-em leading-4 md:leading-5 text-tiny md:text-smaller top-4 md:top-8 right-4 md:right-8 bg-bright-yellow py-px md:py-2px px-half-space z-10"
      >
        {{ tag }}
      </div>
      <MajorityUiMajorityImage
        :src="img"
        alt="Article image"
        class="object-cover absolute w-full h-full inset-0"
        fade-in
        lazy
      />
    </figure>
    <div class="flex flex-col row-start-2 lg:row-start-1 lg:justify-center">
      <h4
        class="uppercase text-dusty-gray font-gt-america-extended text-tiny -tracking-04-em mb-1 md:text-smallest lg:mb-2"
      >
        {{ category }}
      </h4>
      <h3
        class="flex items-end font-bold text-smaller tracking-02-em mb-0 md:text-biggest md:tracking-normal lg:text-display-11 lg:leading-12 lg:mb-8"
      >
        <MajorityUiMajorityLink
          class="no-underline"
          tracking-name="communityArticleBlock"
          tracking-type="community content"
          :to="to"
          :text="title"
        />
      </h3>
      <p
        class="hidden lg:block text-dusty-gray text-base font-light leading-7 mb-8"
      >
        {{ description }}
      </p>
      <MajorityUiMajorityLink
        class="hidden lg:block btn btn-infra-violette z-10"
        tracking-name="communityArticleBlock"
        tracking-type="community content"
        :to="to"
        :text="$messages('action.read_more')"
      />
    </div>
  </article>
</template>

<script>
import { isEmptyOrWhiteSpace } from '@/utils/comparators'
export default {
  props: {
    img: {
      type: String,
      required: true,
      default: ''
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    description: {
      type: String,
      required: true,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      required: true,
      default: ''
    },
    to: {
      type: [String, Object],
      default: ''
    }
  },
  computed: {
    hasTag () {
      return !isEmptyOrWhiteSpace(this.tag)
    }
  }
}
</script>

<style lang="postcss" scoped>
article {
  min-height: 440px;
}

.tag {
  max-width: 60%;
}

article:hover h3 {
    @apply underline;
}

.grid {
  grid-template-rows: repeat(1, minmax(0, 1fr));
  @apply grid-cols-1;

  @screen lg {
     grid-template-columns: minmax(40%, 1fr) minmax(50%, 650px);
  }
}

.btn {
  width: fit-content;
}
</style>
